import { acceptFullNameValue } from './full-name-normalize-value';
export const fullNameViewer = {
    normalizeLoadedValue: acceptFullNameValue
};

//# sourceMappingURL=definition-viewer.js.map